import React from "react";
import { connect } from "react-redux";
import { Flex } from "@chakra-ui/react";
import time from "src/utils/time";
import { Subtitle2, Caption } from "src/atoms/typography";
import SvgContainer from "src/components/SvgContainer";
import { getPairedDevices } from "src/modules/device/duck/selectors/index";
import BlinkingDot from "../BlinkingDot";
import { ReactComponent as ScheduledIcon } from "../icons/scheduled-small.svg";

const INITIAL_UPDATE_INTERVAL_IN_MS = 1000 * 3;
const UPDATE_INTERVAL_IN_MS = 1000 * 29;

const FIFTEEN_SECONDS = 15 * 1000;
const THIRTY_SECONDS = 30 * 1000;
const ONE_MINUTE = 60 * 1000;
const ONE_HOUR = 320 * 1000;

class Connected extends React.Component {
  state = {
    monitoringTime: null
  };
  updateInterval = INITIAL_UPDATE_INTERVAL_IN_MS;

  componentDidMount = () => {
    this.updateMonitoringTime();
    this.intervalId = setInterval(this.updateMonitoringTime, INITIAL_UPDATE_INTERVAL_IN_MS);
  };
  componentWillUnmount = () => {
    clearInterval(this.intervalId);
  };

  updateMonitoringTime = () => {
    const { monitoringStartTime } = this.props;

    const monitoringDuration = time.duration(time().diff(monitoringStartTime)).asMilliseconds();

    this.setState({
      monitoringTime: this.getMonitoringTime(monitoringDuration)
    });

    if (this.updateInterval === INITIAL_UPDATE_INTERVAL_IN_MS && monitoringDuration > ONE_MINUTE) {
      clearInterval(this.intervalId);
      this.intervalId = setInterval(this.updateMonitoringTime, UPDATE_INTERVAL_IN_MS);
      this.updateInterval = UPDATE_INTERVAL_IN_MS;
    }
  };

  getMonitoringTime(monitoringDuration) {
    const { t } = this.props;
    let result;

    if (monitoringDuration < FIFTEEN_SECONDS) {
      result = t("monitoringStarted");
    } else if (monitoringDuration >= FIFTEEN_SECONDS && monitoringDuration < THIRTY_SECONDS) {
      result = t("babyStation.monitoringStatus.connected.monitoringFor", {
        value0: time.duration(FIFTEEN_SECONDS).format("s _")
      });
    } else if (monitoringDuration >= THIRTY_SECONDS && monitoringDuration < ONE_MINUTE) {
      result = t("babyStation.monitoringStatus.connected.monitoringFor", {
        value0: time.duration(THIRTY_SECONDS).format("s _")
      });
    } else if (monitoringDuration >= ONE_MINUTE && monitoringDuration < ONE_HOUR) {
      result = t("babyStation.monitoringStatus.connected.monitoringFor", {
        value0: time.duration(monitoringDuration).format("m _")
      });
    } else {
      result = t("babyStation.monitoringStatus.connected.monitoringFor", {
        value0: time.duration(monitoringDuration).format("h _ m _")
      });
    }
    return result;
  }

  render() {
    const { monitoringTime } = this.state;
    const { parents, pairedDevices, activeScheduledMonitoring, t } = this.props;

    const parentsAsArray = Object.values(parents);
    const numberOfParents = parentsAsArray.length;

    const isMonitoringWithoutParents = activeScheduledMonitoring && numberOfParents === 0;

    const connectedToText =
      numberOfParents === 1 && pairedDevices[parentsAsArray[0].jid]
        ? t("babyStation.monitoringStatus.connectedToParent", {
            value0: pairedDevices[parentsAsArray[0].jid].name
          })
        : t("babyStation.monitoringStatus.connectedToParents", {
            value0: numberOfParents
          });
    const stopDate = time().set({
      hour: activeScheduledMonitoring?.endTime?.hour,
      minute: activeScheduledMonitoring?.endTime?.minute
    });
    const string = isMonitoringWithoutParents
      ? t("scheduler.toStopAt", {
          value0: stopDate.format("HH:mm")
        })
      : connectedToText;
    return (
      <Flex
        flexDirection="column"
        alignItems="center"
        bg="white"
        minWidth={["224px", "320px", "392px"]}
        p={["8px 33px", "12px 35px", "12px 48px"]}
        borderRadius={["27px", "40.5px", "45px"]}
      >
        <Subtitle2
          // fontSize={["12px", "16px", "20px"]}
          fontSize="clamp(1.2rem, 2.29vmin, 2.2rem)"
          color="black"
          position="relative"
          display="flex"
          alignItems="center"
        >
          <BlinkingDot top="unset" />
          <span>{monitoringTime}</span>
        </Subtitle2>
        <Flex alignItems="center">
          {isMonitoringWithoutParents && <SvgContainer icon={ScheduledIcon} mr="4px" />}
          <Caption
            //  fontSize={["10px", "14px", "16px"]}
            fontSize="clamp(1rem, 1.9vmin, 1.6rem)"
            color="black54"
          >
            {string}
          </Caption>
        </Flex>
      </Flex>
    );
  }
}

function mapStateToProps(state) {
  return { pairedDevices: getPairedDevices(state) };
}

export default connect(mapStateToProps)(Connected);
